<script setup lang="ts">
import { SellingMethod } from '~/apiClient';
import { EMPTY_OPTION_VALUE } from '~/constants/filters';
import { AlpFilterableState } from '~/types/filters';

// COMPOSABLES
const { trackSlpSortBy } = useTracking();
const sellingMethod = useSlpSellingMethod();
const { tt } = useTypedI18n();
const { aState, sorting, sortingOptions } = useSlpParams(sellingMethod);

// DATA
const emptyOptionLabel = computed(() => {
    if (sellingMethod.value === SellingMethod.Auction) {
        const labels: Record<AlpFilterableState, string> = {
            Pending: tt('slp.Auction.sorting.defaultByState.Pending'),
            Running: tt('slp.Auction.sorting.defaultByState.Running'),
            Expired: tt('slp.Auction.sorting.defaultByState.Expired'),
        };

        const singleStateSelected = ((): AlpFilterableState | undefined => {
            return aState.value.length === 1 ? aState.value[0] : undefined;
        })();

        return singleStateSelected ? labels[singleStateSelected] : tt('slp.Auction.sorting.defaultByState.all');
    }

    return tt(`slp.sorting.default`);
});

const items = computed(() => {
    return [
        { value: EMPTY_OPTION_VALUE, label: emptyOptionLabel.value },
        ...sortingOptions.value.map(({ value, label }) => ({ label, value: JSON.stringify(value) })),
    ];
});

const selectModel = computed({
    get: () => (sorting.value ? JSON.stringify(sorting.value) : EMPTY_OPTION_VALUE),
    set(value) {
        sorting.value = value === EMPTY_OPTION_VALUE ? undefined : JSON.parse(value);
    },
});
</script>

<template>
    <div class="flex flex-wrap items-center gap-2 sm:justify-end">
        <span>{{ tt(`slp.sorting.title`) }}:</span>
        <USelectMenu v-model="selectModel" :search-input="false" class="w-72" :items="items" value-key="value" @update:model-value="trackSlpSortBy" />
    </div>
</template>
